// extracted by mini-css-extract-plugin
module.exports = {"panel":"X7Hj"};